import { defineStore } from 'pinia'

export const useNativeDataStore = defineStore('nativeDataStore', {
  state: () => ({
    nativeData: null
  })
})
